module.exports = __webpack_public_path__ + "static/media/expiry-hard.d42b008e.svg";